// STEP 3 · rule 7 (B-7b) — no silent default: when the engagement has no stored period end, the screens say in words
// which date they use (the server's engagement_period.period_end_note, EN + AR, sent with the engagement).
import React from "react";
import { useI18n } from "@/contexts/I18nContext";

export default function PeriodEndNote({ engagement, className = "" }) {
  const { lang } = useI18n();
  const e = engagement || {};
  const text = (lang === "ar" && e.period_end_note_ar) || e.period_end_note;
  if (!text) return null;
  return (
    <p className={`text-xs text-amber-700 dark:text-amber-400 ${className}`} data-testid="period-end-note">{text}</p>
  );
}
